import { useEffect } from "react";
import { useAppDispatch } from "../../reduxToolkit/hooks";
import { routes } from "../../routers/routes";
import Breadcrumbs from "../commonComponents/breadcrumbs";
import WishlistBox from "../commonComponents/WishlistBox";
import { fetchProductApiData } from "../../reduxToolkit/reducers/productSlice";

const JobWishlistContainer = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
  }, [dispatch]);
  return (
    <>
      <Breadcrumbs title="Job Wishlist" url={routes.Home.JobDemo1} mainClass="job-breadcrumbs-section" />
      <WishlistBox type="job" />
    </>
  );
};

export default JobWishlistContainer;
